import Ajax from '../../../../util/ajax';
export function zigbeeGetLogRecord(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/0x0101/command/get-log-record';
        const value = {
            'logIndex': payload.logIndex
        };
        ajax.post(url, value);
    };
}
